import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ.js';
import {Attribution, defaults as defaultControls} from 'ol/control.js';
import {fromLonLat} from 'ol/proj';

const attribution = new Attribution({
	collapsible: false,
	attributions: 'Ferenci Tamás, <a href="https://www.tura-mult.hu">tura-mult.hu</a>. Az OSZK Térkép-, Plakát és Kisnyomtatványtára engedélyével; minden további nyilvános felhasználás az OSZK engedélyéhez kötött. A Kartográfiai Vállalat térképei a Cartographia Kft. engedélyével.'
});

const src = new XYZ({
	url: 'https://terkep.tura-mult.hu/' + mapname + '/{z}/{x}/{-y}.png'
})

const map = new Map({
  target: 'map',
  controls: defaultControls({attribution: false}).extend([attribution]),
  layers: [
    new TileLayer({
      source: src
    })
  ],
  view: new View({
	center: [0, 0],
	zoom: 11
  })
});

fetch('https://terkep.tura-mult.hu/' + mapname + '/tilemapresource.xml')
	.then((response) => response.text())
	.then((text) => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(text, "text/xml");
		const centr = fromLonLat([(parseFloat(doc.getElementsByTagName("BoundingBox")[0].getAttribute("minx")) + parseFloat(doc.getElementsByTagName("BoundingBox")[0].getAttribute("maxx")))/2, (parseFloat(doc.getElementsByTagName("BoundingBox")[0].getAttribute("miny")) + parseFloat(doc.getElementsByTagName("BoundingBox")[0].getAttribute("maxy")))/2]);
		map.setView(new View({
			center: centr,
			zoom: 11
		}));
	});